const offerTemplates = {
  'Offer document err_invalid_data': {
    message: 'Offer document contains invalid data.',
  },
  err_not_found: {
    message: 'Offer template not found.',
  },
  err_invalid_file_type: {
    message: 'Invalid file type.',
  },
  err_file_size_too_large: {
    message: 'File size is too large.',
  },
};
export default offerTemplates;
